import * as featureActions from '@core-lib/store/init-store/actions';
import { initialState, IInitStoreState } from '@core-lib/store/init-store/state';
import { createReducer, on, Action, ActionReducer, ReducerTypes } from '@ngrx/store';

// declare our fully typed reducer
export function createReplaceMeReducer<A extends Action = Action>(
	initialState,
	...ons: ReducerTypes<IInitStoreState, any>[]
): ActionReducer<IInitStoreState, A> {
	return createReducer(initialState, ...ons);
}

const featureReducer = createReplaceMeReducer(
	initialState,

	on(featureActions.InitStart, (state, action) => ({
		...state,
		isInitLoading: true,
		isInitFinished: false
	})),

	on(featureActions.InitEnd, (state, action) => ({
		...state,
		isInitLoading: false,
		isInitFinished: true
	}))
);

export function InitStoreReducer(state: IInitStoreState, action: Action): IInitStoreState {
	return featureReducer(state, action);
}
